const SVG = ({ fill = "none", width = "19", height = "20", viewBox = "0 0 19 20" }) => (
  <svg fill={fill} width={width} height={height} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.52554 8.81807L0.707462 0L0.000355676 0.707107L8.81843 9.52518L0 18.3436L0.707107 19.0507L9.52554 10.2323L17.9927 18.6995L18.6999 17.9924L10.2326 9.52518L18.6995 1.05833L17.9924 0.351222L9.52554 8.81807Z"
      fill="white"
    />
  </svg>
);

export default SVG;
